import { useErrorState } from '../stores/useErrorState';
import { useEffect } from 'react';
import { O } from '../lib/EffectExports';
export const useClearSecureFormErrorTimeout = () => {
    const { errorState, setErrorState } = useErrorState();
    useEffect(() => {
        var _a;
        if (((_a = O.getOrUndefined(errorState)) === null || _a === void 0 ? void 0 : _a.code) !== 'secure-form-already-submitted') {
            return undefined;
        }
        const timeoutId = setTimeout(() => {
            setErrorState(undefined);
            clearTimeout(timeoutId);
        }, 5000);
        return () => clearTimeout(timeoutId);
    }, [errorState, setErrorState]);
};
//# sourceMappingURL=useClearSecureFormErrorTimeout.js.map